export default "__VITE_ASSET__zygPdHqg__"